import { useEffect, useRef, useState } from "react";
import { useDisclosure } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import moment from "moment-timezone";
import { CommonAPI } from "../../Apis/commonApi";
import { SellerAPI } from "../../Apis/sellerAPI";
import { BuyerAPI } from "../../Apis/buyerAPI";
import { Sellerscreens, MEETING_REQUEST_STATUS } from "../../Constants/data";
import { useToastWrapper } from "../../Wrapper/toastWrapper";
import actions from "../../redux/Actions";

// Claude: extracted from MeetingList.tsx 23-03-2026
export const formatMeetingDate = (meetingUTC: string) => {
  if (!meetingUTC) return "To be decided";
  const localMoment = moment(meetingUTC).local();
  const today = moment().startOf("day");
  const meetingDay = localMoment.clone().startOf("day");
  const diffDays = meetingDay.diff(today, "days");
  const dateStr = localMoment.format("DD-MMM-YYYY");
  const timeStr = localMoment.format("hh:mm A");
  let dayLabel = "";
  if (diffDays === 0) dayLabel = "Today, ";
  else if (diffDays === -1) dayLabel = "Yesterday, ";
  else if (diffDays === 1) dayLabel = "Tomorrow, ";
  return `${dayLabel}${dateStr} ${timeStr}`;
};

const useMeetingListState = () => {
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleModalClose = () => setIsModalOpen(false);
  const handleModalOpen = () => setIsModalOpen(true);
  const [isCalendarModalOpen, setIsCalendarModalOpen] = useState(false);
  const handleCalendarModalClose = () => setIsCalendarModalOpen(false);
  const handleCalendarModalOpen = () => setIsCalendarModalOpen(true);
  const [date, setDate] = useState("");
  const [time, setTime] = useState<any>("");
  const detectedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [selectedMeet, setSelectedMeet] = useState<any>({});
  const [type, setType] = useState<"new" | "edit">("new");
  const [responder, setResponder] = useState<any>("");
  const { success, error } = useToastWrapper();
  const [meetings, setMeetings] = useState<any>([]);
  const [userPlan, setUserPlan] = useState<any>({});
  const user = useSelector((state: any) => state.user);
  const [meetingCounts, setMeetingCounts] = useState<any>({});
  const [userData, setUserData] = useState<any>({});
  const [userMobileNumber, setUserMobileNumber] = useState<any>("");
  const [userTimezone, setUserTimezone] = useState<any>("");
  const [todayDate, setTodayDate] = useState<any>("");
  const [isRedirected, setIsRedirected] = useState(false);
  const [activeId, setActiveId] = useState("");
  const itemRef = useRef<HTMLDivElement>();
  const meetingContainerRef = useRef<HTMLDivElement>();
  const [searchParams] = useSearchParams();
  const [activeMeetingItem, setActiveMeetingItem] = useState<any>({});
  const [changeConfirmationModal, setChangeConfirmationModal] = useState(false);
  const [selectedChangeMeeting, setSelectedChangeMeeting] = useState<any>(null);

  const { isOpen: isDrawerOpen, onOpen: onDrawerOpen, onClose: onDrawerClose } = useDisclosure();
  const [selectedProfile, setSelectedProfile] = useState<any>(null);
  const [selectedMeetingItem, setSelectedMeetingItem] = useState<any>(null);
  const [drawerNotes, setDrawerNotes] = useState<string>("");
  const [drawerSellerEvents, setDrawerSellerEvents] = useState<any[]>([]);

  const dispatch = useDispatch();

  const [meetConfirm, setMeetConfirm] = useState(false);
  const handleOpenChangeConfirmationModal = () => setChangeConfirmationModal(true);
  const handleCloseChangeConfirmationModal = () => {
    setChangeConfirmationModal(false);
    setSelectedChangeMeeting(null);
  };

  const [feedbackModal, setFeedbackModal] = useState(false);
  const [selectedFeedbackMeeting, setSelectedFeedbackMeeting] = useState<any>({});
  const [submittedFeedbacks, setSubmittedFeedbacks] = useState<Set<string>>(() => {
    const stored = localStorage.getItem("submittedFeedbacks");
    return stored ? new Set(JSON.parse(stored)) : new Set();
  });

  const [releModal, setReleModal] = useState(false);
  const [relevanceData, setRelevanceData] = useState({
    prequalified_company_name: "",
    prequalified_user_id: [] as string[],
    event_id: "",
    status: "Under_Research",
  });
  const [buyerRelevanceData, setBuyerRelevanceData] = useState({
    prequalified_company_name: "",
    prequalified_user_id: "",
    event_id: "",
    status: "Under_Research",
  });
  const [meetingRelevanceStatus, setMeetingRelevanceStatus] = useState<any>({});

  const handleOpenRelevanceModal = () => setReleModal(true);
  const handleCloseRelevanceModal = () => setReleModal(false);

  const handleOpenFeedbackModal = () => setFeedbackModal(true);
  const handleCloseFeedbackModal = () => {
    setFeedbackModal(false);
    setSelectedFeedbackMeeting({});
  };

  const updateSubmittedFeedbacks = (meetingId: string) => {
    setSubmittedFeedbacks((prev) => {
      const newSet = new Set(prev);
      newSet.add(meetingId);
      localStorage.setItem("submittedFeedbacks", JSON.stringify(Array.from(newSet)));
      return newSet;
    });
  };

  const isFeedbackVisible = (meeting: any): boolean => {
    if (submittedFeedbacks.has(meeting._id)) return false;
    if (user.role !== "Seller") return false;
    // Responder sees their responderStatus; requester sees requesterStatus
    const meetingStatus =
      user.user === meeting.responderId ? meeting.responderStatus : meeting.requesterStatus;
    if (meetingStatus !== MEETING_REQUEST_STATUS.CLOSED) return false;
    const meetingClosedTime = moment.utc(meeting.updatedAt);
    const currentTime = moment.utc();
    const timeLimitInMinutes = 24 * 60;
    const timeDifferenceInMinutes = currentTime.diff(meetingClosedTime, "minutes");
    console.log(
      `Meeting ${meeting._id}: closed at ${meetingClosedTime.format()}, current time ${currentTime.format()}, diff: ${timeDifferenceInMinutes} minutes`
    );
    return timeDifferenceInMinutes < timeLimitInMinutes && timeDifferenceInMinutes >= 0;
  };

  const handleFeedbackClick = (meeting: any) => {
    setSelectedFeedbackMeeting(meeting);
    handleOpenFeedbackModal();
  };

  const handleFeedbackYes = async () => {
    try {
      updateSubmittedFeedbacks(selectedFeedbackMeeting._id);
      handleCloseFeedbackModal();
      success("Thank you for your feedback!");
    } catch (err) {
      console.error("Error submitting feedback:", err);
      error("Failed to submit feedback. Please try again.");
    }
  };

  const handleOpenMeetConfirmModal = (id: any) => {
    setActiveId(id);
    setMeetConfirm(true);
  };
  const handleCloseMeetConfirmModal = () => setMeetConfirm(false);

  const [meetTimeConfirm, setMeetTimeConfirm] = useState(false);
  const handleOpenMeetTimeConfirmModal = () => setMeetTimeConfirm(true);
  const handleCloseMeetTimeConfirmModal = () => {
    setActiveMeetingItem({});
    setMeetTimeConfirm(false);
  };

  const findRecentDate = (data: any) => {
    if (searchParams.get("id")) {
      let meetId: string = searchParams.get("id") || "";
      data.some((item: any) => {
        if (item._id == meetId) item.latestMeeting = true;
      });
      setIsRedirected(true);
    } else {
      let today = new Date();
      let todayInTime = today.getTime();
      data.some((item: any) => {
        let pDate = new Date(item.proposedDate).getTime();
        if (pDate >= todayInTime) {
          item.latestMeeting = true;
          return item;
        }
      });
    }
    return data;
  };

  const compareTimeDifference = (
    time1: string,
    time2: string,
    date1: string,
    date2: string
  ) => {
    const [hours1, minutes1] = time1.split(":").map(Number);
    const [hours2, minutes2] = time2.split(":").map(Number);
    const day1 = new Date(date1).getDate();
    const day2 = new Date(date2).getDate();
    const month1 = new Date(date1).getMonth();
    const month2 = new Date(date2).getMonth();
    const year1 = new Date(date1).getFullYear();
    const year2 = new Date(date2).getFullYear();
    const totalMinutes1 = hours1 * 60 + minutes1;
    const totalMinutes2 = hours2 * 60 + minutes2;
    if (day1 === day2 && month1 === month2 && year1 === year2) {
      const difference = Math.abs(totalMinutes1 - totalMinutes2);
      return difference > 30;
    } else {
      if (hours1 === 23 || hours1 === 0 || hours2 === 23 || hours2 === 0) {
        const difference = Math.abs(totalMinutes1 - totalMinutes2);
        return difference > 30;
      }
    }
  };

  // Relevance status is keyed by the OTHER party's company name + eventId
  const getMeetingRelevanceStatus = async (meetingList: any[]) => {
    try {
      const relevanceStatusMap: any = {};
      const companyEventPairs = new Set();
      meetingList.forEach((meeting) => {
        // The "other party" company: if I am the responder, the other party is the requester
        const companyName =
          user.user === meeting.responderId ? meeting.requesterCompany : meeting.responderCompany;
        const eventId = meeting.eventId;
        companyEventPairs.add(`${companyName}-${eventId}`);
      });

      for (const pair of Array.from(companyEventPairs)) {
        const [companyName, eventId] = (pair as string).split("-");
        try {
          let data;
          if (user.role === "Seller") {
            // Seller prequalifying buyers
            data = await SellerAPI.getBuyerCompaniesV2({ eventId, search: companyName });
          } else {
            // Buyer prequalifying sellers
            data = await BuyerAPI.getSellers({ eventId, search: companyName });
          }
          if (data.success && data.data.data.length > 0) {
            const companyData = data.data.data.find((c: any) => c.companyName === companyName);
            if (companyData) {
              relevanceStatusMap[`${companyName}-${eventId}`] = companyData.prequalificationStatus;
            }
          }
        } catch (err) {
          console.log(`Error fetching relevance for ${companyName}:`, err);
          relevanceStatusMap[`${companyName}-${eventId}`] = "Under_Research";
        }
      }
      setMeetingRelevanceStatus(relevanceStatusMap);
    } catch (err) {
      console.log("Error getting meeting relevance status:", err);
    }
  };

  const getRelevanceStatusForMeeting = (meeting: any) => {
    // Other party's company: responder sees requester; requester sees responder
    const companyName =
      user.user === meeting.responderId ? meeting.requesterCompany : meeting.responderCompany;
    const eventId = meeting.eventId;
    return meetingRelevanceStatus[`${companyName}-${eventId}`] || "Under_Research";
  };

  const handleRelevanceClick = (meeting: any) => {
    // Other party's company: responder sees requester; requester sees responder
    const companyName =
      user.user === meeting.responderId ? meeting.requesterCompany : meeting.responderCompany;

    if (user.role === "Seller") {
      // Seller prequalifying buyers
      const buyerId = meeting.buyerId;
      setRelevanceData({
        prequalified_company_name: companyName,
        prequalified_user_id: [buyerId],
        event_id: meeting.eventId,
        status: getRelevanceStatusForMeeting(meeting),
      });
    } else {
      // Buyer prequalifying sellers — other party's userId
      const sellerId =
        user.user === meeting.responderId ? meeting.requesterId : meeting.responderId;
      setBuyerRelevanceData({
        prequalified_company_name: companyName,
        prequalified_user_id: sellerId,
        event_id: meeting.eventId,
        status: getRelevanceStatusForMeeting(meeting),
      });
    }
    handleOpenRelevanceModal();
  };

  const reloadRelevanceData = async () => {
    await getMeetingRelevanceStatus(meetings);
  };

  const getPlanDetails = async () => {
    try {
      let userId = user && user?.role == "Seller" ? user.user : "";
      if (user && user?.role == "Seller") {
        const [planDetails] = await Promise.all([SellerAPI.getEventSellerProfile(userId)]);
        console.log("getPlanDetails: API response =", planDetails);
        console.log("getPlanDetails: Setting userPlan to =", planDetails?.data?.data);
        if (planDetails) setUserPlan(planDetails?.data?.data);
      }
    } catch (err: any) {
      console.error("Error in getPlanDetails:", err);
      console.log(err);
    }
  };

  const checkMeetStatus = async (item: any) => {
    setLoading(true);
    try {
      const response = await CommonAPI.CheckMeetingAcceptAllowed(item._id);
      if (response) {
        const flag = response.data.data.isAllowed;
        if (flag) {
          handleUpdate(item._id, { response: MEETING_REQUEST_STATUS.CONFIRM });
          handleCloseMeetTimeConfirmModal();
        } else {
          setActiveMeetingItem(item);
          console.log("setActiveMeetingItem:", item);
          handleOpenMeetTimeConfirmModal();
        }
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const checkMeetStatusForChange = async (item: any, obj: any) => {
    setLoading(true);
    console.log("checkMeetStatusForChange input obj is:", obj);
    try {
      const response = await CommonAPI.CheckMeetingChangeAllowed(item._id, date, time);
      if (response) {
        const flag = response.data.data.isAllowed;
        if (flag) {
          const updateMeetingResponse = await CommonAPI.UpdateMeeting(selectedMeet._id, obj);
          if (updateMeetingResponse) {
            success("Meeting request updated");
            handleCalendarModalClose();
            setDate("");
            setTime("");
            getData();
          }
        } else {
          handleOpenMeetTimeConfirmModal();
        }
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const getData = async () => {
    setMeetings([]);
    setLoading(true);
    try {
      getPlanDetails();
      const [userProfile, allMeetings] = await Promise.all([
        user && user?.role == "Seller"
          ? SellerAPI.getSellerProfile()
          : BuyerAPI.getBuyerProfile(),
        CommonAPI.GetMeeting({ status: status == "total" ? undefined : status }),
      ]);
      console.log("getData: allMeetings API response =", allMeetings);
      if (userProfile) {
        console.log("userProfile is:", userProfile);
        setUserData(userProfile?.data?.data);
        if (user && user?.role == "Seller") {
          setUserMobileNumber(userProfile?.data?.data.personPhoneNumber);
          setUserTimezone(userProfile?.data?.data.companyTimezone ?? "UTC");
        } else {
          setUserMobileNumber(userProfile?.data?.data.buyerPhoneNumber);
          setUserTimezone(userProfile?.data?.data.buyerTimezone ?? "UTC");
        }
      }
      if (allMeetings) {
        let response = JSON.parse(JSON.stringify(allMeetings.data.data));
        response.sort(
          (a: any, b: any) =>
            new Date(a.proposedDate).getTime() - new Date(b.proposedDate).getTime()
        );
        const alteredResponse = findRecentDate(response);
        console.log("getData: Setting meetings to =", alteredResponse);
        setMeetings(alteredResponse);
        setMeetingCounts(allMeetings.data.meetingCounts);
        await getMeetingRelevanceStatus(alteredResponse);
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setMeetings([]);
      setLoading(false);
    }
  };

  // Claude: enabled 10 min before meeting start, active for 60 min after start (70-min total window) 08-04-2026
  const allowCall = (proposedDateStr: string, proposedTime: string) => {
    if (!proposedDateStr || !proposedTime) return false;
    const [h, m] = proposedTime.split(":").map(Number);
    const start = new Date(proposedDateStr);
    start.setHours(h, m, 0, 0);
    const early = new Date(start.getTime() - 10 * 60 * 1000);
    const end = new Date(start.getTime() + 60 * 60 * 1000);
    const now = new Date();
    return now >= early && now <= end;
  };

  // Claude: N44 — save meetingURL for a confirmed meeting, refresh list after 26-03-2026
  const handleUpdateMeetingUrl = async (id: string, meetingURL: string) => {
    try {
      await CommonAPI.updateMeetingUrl(id, meetingURL);
      getData();
      success("Meeting link saved.");
    } catch (err) {
      console.log(err);
      error("Failed to save meeting link.");
    }
  };

  const handleUpdate = async (id: string, data: any) => {
    try {
      const updateMeetingResponse = await CommonAPI.UpdateMeeting(id, { ...data });
      if (updateMeetingResponse) {
        getData();
        getPlanDetails();
        setActiveId("");
        handleCloseMeetConfirmModal();
        setActiveMeetingItem({});
        success("Meeting request updated");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleFeedbackNo = async () => {
    try {
      await handleUpdate(selectedFeedbackMeeting._id, {
        response: MEETING_REQUEST_STATUS.INCOMPLETE,
      });
      updateSubmittedFeedbacks(selectedFeedbackMeeting._id);
      handleCloseFeedbackModal();
      success(
        "Thank you for your feedback. You would be able to initiate another meeting with the same party without any additional subscription charges. Please reachout to support@aftr.network for further assistance."
      );
    } catch (err) {
      console.error("Error updating meeting status:", err);
      error("Failed to submit feedback. Please try again.");
    }
  };

  const handleSubmitEditOrNew = async () => {
    if (!date || !time) return error("Please fill all the fields");
    const selectedDate = new Date(date);
    selectedDate.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (selectedDate.getTime() === today.getTime()) {
      const [hours, minutes] = time.split(":");
      const selectedTime = new Date();
      selectedTime.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);
      if (selectedTime.getTime() < new Date().getTime()) {
        error("Please enter correct value for time");
        return;
      }
    }
    try {
      // responderId is the OTHER party: if I am requester, responder is responderId; if I am responder, I send back to requesterId
      const responderId =
        user.user == responder.responderId ? responder.requesterId : responder.responderId;
      if (type == "new") {
        // Claude: only include eventId if present — direct meetings have no event context 19-02-2026
        const obj = {
          proposedDate: date,
          proposedTime: time,
          ...(responder.eventId ? { eventId: responder.eventId } : {}),
        };
        const postCreateMeetingResponse = await CommonAPI.PostCreateMeeting(responderId, obj);
        if (postCreateMeetingResponse) {
          success("Meeting request updated");
          handleCalendarModalClose();
          setDate("");
          setTime("");
          getData();
          getPlanDetails();
        }
      } else {
        console.log("Change Meeting - detectedTimezone:", detectedTimezone);
        const meetingLocal = moment.tz(
          `${date} ${time}`,
          "YYYY-MM-DD HH:mm",
          detectedTimezone
        );
        const meetingUTC = meetingLocal.utc();
        console.log("meetingUTC string format", meetingUTC.format());
        console.log("meetingUTC date format", meetingUTC.toDate());
        const obj = {
          proposedDate: date,
          proposedTime: time,
          meetingUTC: meetingUTC.toDate(),
          response: MEETING_REQUEST_STATUS.PROPOSE_ALTERNATE_DATE,
        };
        checkMeetStatusForChange(selectedMeet, obj);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleCall = async (id: any) => {};

  const createUTCDate = (dateStr: string, timeStr: string): Date | null => {
    const timeParts = timeStr.split(":");
    if (timeParts.length !== 2) return null;
    const hours = parseInt(timeParts[0]);
    const minutes = parseInt(timeParts[1]);
    if (isNaN(hours) || isNaN(minutes)) return null;
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return null;
    return new Date(
      Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), hours, minutes)
    );
  };

  const isPendingMeeting = (meeting: any, userId: string): boolean => {
    return (
      meeting.responderId === userId &&
      (meeting.responderStatus === MEETING_REQUEST_STATUS.REQUEST_RECEIVED ||
        meeting.responderStatus === MEETING_REQUEST_STATUS.PUT_ON_HOLD) &&
      !!meeting.proposedDate &&
      !!meeting.proposedTime
    );
  };

  const isBeforeProposed = (meeting: any, proposedUTC: Date): boolean => {
    const meetingUTC = createUTCDate(meeting.proposedDate, meeting.proposedTime);
    return !!meetingUTC && meetingUTC < proposedUTC;
  };

  const isPendingMeetingsPresent = (proposedDateStr: string, proposedTime: string): boolean => {
    if (!proposedDateStr || !proposedTime) {
      console.error("Missing proposed date or time");
      return true;
    }
    const userId = user.user;
    const proposedUTC = createUTCDate(proposedDateStr, proposedTime);
    if (!proposedUTC) {
      console.error("Invalid proposed date/time format");
      return true;
    }
    console.log("Checking against proposed UTC:", proposedUTC.toISOString());
    const pendingMeetings = meetings.filter((m: any) => {
      return isPendingMeeting(m, userId) && isBeforeProposed(m, proposedUTC);
    });
    console.log("Filtered Meeting are:", pendingMeetings);
    console.log(`Filtered ${pendingMeetings.length} pending meetings BEFORE proposed time`);
    if (pendingMeetings.length >= userPlan.pendingMeetingsLimit) {
      console.log(
        `Blocked! ${pendingMeetings.length} pending meetings exceed limit of ${userPlan.pendingMeetingsLimit}`
      );
      return true;
    }
    console.log(`Allowed: ${pendingMeetings.length} pending meetings within limit`);
    return false;
  };

  const isAcceptActionAllowed = (item: any) => {
    if (isPendingMeetingsPresent(item.proposedDate, item.proposedTime)) {
      error(
        "Unable to confirm this meeting, as there are atleast " +
          userPlan.pendingMeetingsLimit +
          " meetings before this meeting that are awaiting your response."
      );
      return false;
    }
    return true;
  };

  const changeMeetingRequestStatus = async () => {
    try {
      const obj = {
        proposedDate: date,
        proposedTime: time,
        response: MEETING_REQUEST_STATUS.PROPOSE_ALTERNATE_DATE,
      };
      const updateMeetingResponse = await CommonAPI.UpdateMeeting(selectedMeet._id, obj);
      if (updateMeetingResponse) {
        success("Meeting request updated");
        handleCalendarModalClose();
        setDate("");
        setTime("");
        getData();
        setSelectedMeet({});
      }
    } catch (err) {
      console.log(err);
      error("Unable to change meeting!");
    }
  };

  const buttonTypeAcceptClick = (id: string) => {
    const currentMeeting = meetings.find((m: any) => m._id === id);
    if (!currentMeeting) {
      error("Meeting data not available");
      return;
    }
    if (user && user.role == "Seller") {
      const allowed = isAcceptActionAllowed(currentMeeting);
      console.log("isAcceptActionAllowed returned:", allowed);
      if (allowed) checkMeetStatus(currentMeeting);
    } else {
      handleUpdate(id, { response: MEETING_REQUEST_STATUS.CONFIRM });
    }
  };

  // Other party details: if I am the responder, the other party is the requester (and vice versa)
  const getOtherPartyDetails = (item: any) => {
    if (user.user == item.responderId) return item.requesterDetails;
    return item.responderDetails;
  };

  const openProfileDrawer = async (item: any) => {
    const otherParty = getOtherPartyDetails(item);
    setSelectedProfile(otherParty);
    setSelectedMeetingItem(item);
    setDrawerNotes("");
    setDrawerSellerEvents([]);
    onDrawerOpen();
    try {
      const res = await CommonAPI.getNotes({ eventId: item.eventId, forUser: otherParty?._id });
      setDrawerNotes(res?.data?.data?.body || "");
    } catch (_) {}
    // Claude: Fetch tradeshows if the other party is a seller 24-02-2026
    const isSeller = !!otherParty?.personName;
    if (isSeller && otherParty?._id) {
      try {
        const res = await BuyerAPI.getSellerEvents(otherParty._id);
        setDrawerSellerEvents(res?.data?.data || []);
      } catch (_) {}
    }
  };

  const [status, setStatus] = useState("");

  useEffect(() => {
    if (status) getData();
  }, [status]);

  // Claude: Auto-scroll to nearest upcoming meeting when screen opens 09-02-2026
  useEffect(() => {
    if (meetings.length > 0) {
      const timer = setTimeout(() => {
        if (meetingContainerRef.current && itemRef.current) {
          meetingContainerRef.current.scrollTop = (itemRef.current as any).offsetTop - 180;
        }
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [meetings]);

  useEffect(() => {
    const s = searchParams.get("status");
    let date = new Date();
    setTodayDate(date.getTime());
    if (s) {
      setStatus(s);
    } else {
      setStatus(MEETING_REQUEST_STATUS.TOTAL);
    }
    if (user && user?.role == "Seller") {
      dispatch(actions.sellerMenu.set({ activeMenu: Sellerscreens.CALENDAR }));
    } else {
      dispatch(actions.buyerMenu.set({ activeMenu: Sellerscreens.CALENDAR }));
    }
  }, []);

  useEffect(() => {
    const DEBUG_MODE = false;
    if (!DEBUG_MODE) {
      const interval = setInterval(() => {
        window.location.reload();
      }, 60000);
      return () => clearInterval(interval);
    }
  }, []);

  return {
    loading, user,
    isModalOpen, handleModalClose, handleModalOpen,
    isCalendarModalOpen, handleCalendarModalClose, handleCalendarModalOpen,
    date, setDate, time, setTime,
    selectedMeet, setSelectedMeet, type, setType,
    responder, setResponder,
    success, error,
    meetings, userPlan, meetingCounts,
    userData, userMobileNumber, userTimezone, todayDate,
    isRedirected, activeId,
    itemRef, meetingContainerRef,
    activeMeetingItem, setActiveMeetingItem,
    changeConfirmationModal, selectedChangeMeeting, setSelectedChangeMeeting,
    handleOpenChangeConfirmationModal, handleCloseChangeConfirmationModal,
    isDrawerOpen, onDrawerClose,
    selectedProfile, selectedMeetingItem,
    drawerNotes, drawerSellerEvents,
    meetConfirm, handleOpenMeetConfirmModal, handleCloseMeetConfirmModal,
    meetTimeConfirm, handleOpenMeetTimeConfirmModal, handleCloseMeetTimeConfirmModal,
    feedbackModal, selectedFeedbackMeeting,
    handleCloseFeedbackModal,
    releModal, relevanceData, buyerRelevanceData,
    handleCloseRelevanceModal,
    status, setStatus, meetingRelevanceStatus,
    // functions passed to child components
    getData, handleUpdate, handleUpdateMeetingUrl,
    allowCall, handleCall,
    buttonTypeAcceptClick,
    changeMeetingRequestStatus,
    getRelevanceStatusForMeeting, handleRelevanceClick, reloadRelevanceData,
    isFeedbackVisible, handleFeedbackClick, handleFeedbackYes, handleFeedbackNo,
    getOtherPartyDetails, openProfileDrawer,
    handleSubmitEditOrNew,
  };
};

export default useMeetingListState;
